import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { PRD5030_R01ResultDto } from "./Dto_PRD5030_R01";
import { PRD5030_R01Filter } from "./Store_PRD5030_R01";

const baseUrl = `${config.apiUrl}/PRD5030_R01`;

const getParams = (filter: Partial<PRD5030_R01Filter>) => ({
	compCd: filter.compCd || undefined,
	year: filter.year,
	workplaceCd: filter.workplaceCd || undefined,
	itemGroup: filter.itemGroup || undefined,
	itemCd: filter.itemCd || undefined,
});

export const getPRD5030_R01List = async (
	option: string,
	filter: Partial<PRD5030_R01Filter>
) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<PRD5030_R01ResultDto[]>>(url, { params: getParams(filter) });
};
